var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contest-picks-page--body" }, [
    !_vm.mobileBigAndBelow
      ? _c("div", { staticClass: "contest-body--name" }, [
          _vm._v(_vm._s(_vm.contestName))
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "contest-body-info" }, [
      _c("div", { staticClass: "contest-body-info--round" }, [
        _c("span", { staticClass: "picks" }, [
          _vm._v(
            _vm._s(
              _vm.$t("Contests.Picks.Body.Round.Picks", {
                roundNo: _vm.roundNo
              })
            )
          )
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "time-left" }, [
          _vm._v(_vm._s(_vm.$t("Contests.Picks.Body.Time.Left")) + " "),
          _c("span", [_vm._v("(" + _vm._s(_vm.roundTimeLeft) + ")")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "contest-body-info--used" }, [
        _c("span", { staticClass: "used-picks" }, [
          _vm._v(
            " " +
              _vm._s(_vm.$t("Contests.Picks.Body.Used.Picks")) +
              " " +
              _vm._s(_vm.picksCount) +
              " / " +
              _vm._s(_vm.contestMaxPicksPerRound)
          ),
          _c("span", { staticClass: "used-picks--scale" }, [
            _c("span", {
              staticClass: "used-picks--scale-marked",
              style: { width: _vm.picksScaleWidth + "%" }
            })
          ])
        ]),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "clear-picks", on: { click: _vm.clearAllPicks } },
          [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("Contests.Picks.Body.Clear.Picks")))
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "trash" })
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "contest-body-tables" }, [_c("contests-table")], 1)
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-514533a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-514533a0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/contests/contestPicksBody.vue
// module id = null
// module chunks = 